import { DealInitialStateType } from "../types/initialStateType";

export const dealIinitialState: DealInitialStateType = {
  deal: undefined,
};
